import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';

const ListItem = ({ leftSlot, rightSlot, clickable = false, disabled = false, className, onClick, rightSlotWrap = 'never', children, ...rest })=>{
    const handleClick = ()=>{
        if (onClick) {
            onClick();
        }
    };
    const handleKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick();
        }
    };
    const getTabIndex = ()=>{
        if (!clickable) return undefined;
        return disabled ? -1 : 0;
    };
    return jsx("li", {
        className: classNames('cb-list-item', {
            clickable: clickable && !disabled,
            disabled,
            'right-slot-wrap-never': rightSlotWrap === 'never',
            'right-slot-wrap-auto': rightSlotWrap === 'auto',
            'right-slot-wrap-always': rightSlotWrap === 'always'
        }, className),
        "data-testid": "list-item",
        onClick: clickable && !disabled ? handleClick : undefined,
        onKeyDown: clickable && !disabled ? handleKeyDown : undefined,
        role: clickable ? 'button' : undefined,
        tabIndex: getTabIndex(),
        ...rest,
        children: jsxs("div", {
            className: "cb-list-item-content",
            children: [
                Boolean(leftSlot) && jsx("div", {
                    className: "left-slot",
                    children: leftSlot
                }),
                Boolean(children) && jsx("div", {
                    className: "main-content",
                    children: children
                }),
                Boolean(rightSlot) && jsx("div", {
                    className: "right-slot",
                    children: rightSlot
                })
            ]
        })
    });
};
ListItem.displayName = 'List.Item';

export { ListItem };
//# sourceMappingURL=List.Item.es.js.map
